import {Component, EventEmitter, HostBinding, Input, OnDestroy, OnInit, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import { Subscription } from 'rxjs';

import { NavbarService } from '../navbar.service';
import {ScrollbarDirective} from '../../../directives/scrollbar/scrollbar.directive';
import {MainComponent} from '../../../main.component';
import {NavigationService} from '../navigation.service';

@Component({
    selector     : 'ngc-navbar',
    templateUrl  : './navbar.component.html',
    styleUrls    : ['./navbar.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class NavbarComponent implements OnInit, OnDestroy {

    private folded: boolean;
    @Output() onFolded = new EventEmitter<boolean>();

    @HostBinding('class.close') isClosed: boolean;
    @HostBinding('class.folded') isFoldedActive: boolean;
    @HostBinding('class.initialized') initialized: boolean;
    @ViewChild(ScrollbarDirective, { static: true }) scrollbarDirective;


    navigationServiceWatcher: Subscription;
    navigationModel: any[] = [];
    navigationModelChangeSubscription: Subscription;

    @Input()
        layout = 'vertical';

    constructor(
        private mainComponent: MainComponent,
        private navigationService: NavigationService,
        private navBarService: NavbarService,
    ) {

        this.navigationModelChangeSubscription =
            this.navigationService.onNavigationModelChange
                .subscribe((navigationModel) => {
                    this.navigationModel = navigationModel;
                });

        navBarService.setNavBar(this);

        this.navigationServiceWatcher =
            this.navigationService.onNavCollapseToggle.subscribe(() => {
                if (this.scrollbarDirective) {
                    this.scrollbarDirective.update();
                }
            }
            );
    }

    ngOnInit() {
        this.isClosed = false;
        this.isFoldedActive = this.folded;
        this.initialized = false;
        setTimeout(() => {
            this.initialized = true;
        });


    }

    ngOnDestroy() {
        this.navigationModelChangeSubscription.unsubscribe();
        this.navigationServiceWatcher.unsubscribe();
    }
}
